module.exports = __webpack_public_path__ + "3ba97b998baf0231a500c76f5d6fbce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-shock.png
// module id = 2059
// module chunks = 4